/* Add-to-cart morph: button collapses into a spinner, then expands to "Added".
   The cart drawer is updated silently and never opens. */
(function () {
  var MIN_SPIN = 650, HOLD = 1800;
  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }
  function prep(btn) {
    if (btn._atc) return btn._atc;
    btn.classList.add('atc');
    var fx = document.createElement('span');
    fx.className = 'atc__fx';
    fx.setAttribute('aria-hidden', 'true');
    fx.innerHTML = '<span class="atc__ring"></span><span class="atc__done"><svg viewBox="0 0 16 16"><path d="M3 8.6l3.2 3.1L13 4.8"/></svg><span>Added</span></span>';
    btn.appendChild(fx);
    btn._atc = { t0: 0, timer: 0 };
    return btn._atc;
  }
  function start(btn) {
    if (!btn) return;
    var s = prep(btn);
    clearTimeout(s.timer);
    btn.style.setProperty('--atc-r', (btn.offsetHeight / 2) + 'px');
    btn.classList.remove('is-added', 'is-shake');
    btn.classList.add('is-loading');
    s.t0 = performance.now();
  }
  function after(btn) {
    var s = prep(btn);
    var left = Math.max(0, MIN_SPIN - (performance.now() - s.t0));
    return new Promise(function (r) { setTimeout(r, left); });
  }
  function success(btn, onReset) {
    if (!btn) return Promise.resolve();
    var s = prep(btn);
    return after(btn).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      announce('Added to cart');
      bump();
      s.timer = setTimeout(function () {
        btn.classList.remove('is-added');
        if (onReset) onReset();
      }, HOLD);
    });
  }
  function fail(btn) {
    if (!btn) return Promise.resolve();
    return after(btn).then(function () {
      btn.classList.remove('is-loading');
      void btn.offsetWidth;
      btn.classList.add('is-shake');
      setTimeout(function () { btn.classList.remove('is-shake'); }, 500);
    });
  }
  function bump() {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (el) {
      el.classList.remove('atc-bump');
      void el.offsetWidth;
      el.classList.add('atc-bump');
    });
  }
  /* Update the drawer + header count without opening anything */
  function silent(res) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (cart && cart.renderContents && res && res.sections) {
      cart.open = function () {};
      try { cart.renderContents(res); } catch (e) {}
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      setTimeout(function () { delete cart.open; }, 120);
      return;
    }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !j['cart-icon-bubble']) return;
        var d = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        el.innerHTML = d ? d.innerHTML : j['cart-icon-bubble'];
      })
      .catch(function () {});
  }
  window.ATC = { start: start, success: success, fail: fail, silent: silent };
})();
